export const PolicyData = [

  {

    body: `Our cab booking app provides a convenient and reliable way to book rides and travel comfortably to your destination. With a user-friendly interface and a wide range of features, we aim to enhance your transportation experience. Here's what you can expect from our cab booking app:`,

    content:[

      {

      title:' Easy Registration:',

      description: ` Download the app and sign up with your email address or phone number.

      Provide the necessary details, such as your name and preferred payment method, to create your account.`

    },

    {

      title:' Quick Booking Process:',

      description: ` Add your pickup location and destination to request a ride.

      Choose from various vehicle options based on your needs, such as economy cars, sedans, or SUVs.

      View estimated fares and arrival times before confirming your booking.`

    },

    {

      title:' Real-Time Tracking:',

      description: ` Track your assigned driver's location and estimated time of arrival in real-time on the map within the app.

      Get updates on any changes to the pickup or drop-off locations.`

    },

    {

      title:' Safe and Professional Drivers:',

      description: `Our drivers undergo thorough background checks and are selected for their professionalism and driving skills.

      They are committed to providing you with a safe and comfortable journey.`

    },

    {

      title:' Transparent Pricing:',

      description: ` Fare estimates are provided upfront, taking into account factors such as distance, time, and any additional charges like tolls or surcharges.

      You'll have a clear understanding of the cost before confirming your booking.`

    },

    {

      title:'Multiple Payment Options:',

      description: ` Choose from various payment methods, including credit cards, debit cards, and digital wallets, for a seamless and secure payment experience.

      Payment details can be saved securely for quick and hassle-free transactions.`

    },

    {

      title:' Reliable Customer Support:',

      description: `Our dedicated customer support team is available to assist you with any inquiries, concerns, or issues you may have.

      Contact us through the app, website, or other specified communication channels.`

    },

    {

      title:' Ride History and Receipts:',

      description: ` Access your ride history within the app to view past trips, including details like pickup/drop-off locations, fare breakdowns, and driver information.

      Receipts for completed rides can be easily downloaded or emailed for your records.`

    },

    {

      title:'Ratings and Reviews:',

      description: `Rate and provide feedback on your ride experience, helping us maintain high-quality service standards.

      We value your feedback and continuously strive to improve our services based on your input.`

    },

    {

      title:'Special Features and Promotions:',

      description: ` Stay updated with our app for special features, promotions, and discounts that enhance your ride experience and provide cost-saving opportunities.

      Experience the convenience and reliability of our cab booking app for all your transportation needs. Download [Your App Name] today and enjoy a seamless travel experience!`,

    },

     ]

} ]

